import { baseDeleteQuery } from '../../../../utility/sb-api/sb-api.service';
import { BILLING_ADDRESS } from '../../../../utility/constants';

export const removeAddress = (address) =>
  baseDeleteQuery(
    address.type === BILLING_ADDRESS
      ? `addresses/billing/${address.id}`
      : `addresses/delivery/${address.id}`,
    null,
    address.type === BILLING_ADDRESS
      ? 'removeBillingAddressSuccess'
      : 'removeDeliveryAddressSuccess',
    address.type === BILLING_ADDRESS
      ? 'removeBillingAddressError'
      : 'removeDeliveryAddressError',
  );
